module.exports = __webpack_public_path__ + "img/case-exhibition.32c73b07.png";